import React, { Suspense } from 'react';
import ErrorBoundary from 'components/ErrorBoundary';

function LoadWidget() {
  return React.lazy(() => import(`./RenderChart`));
}

export default class RenderChartLoadable extends React.Component {
  constructor() {
    super();
    this.state = { Component: false };
  }

  componentDidMount() {
    setTimeout(() => {
      this.setState({ Component: LoadWidget() });
    }, 0);
  }

  render() {
    const { Component } = this.state;

    if (!Component) {
      return null;
    }

    return (
      <ErrorBoundary>
        <Suspense fallback={<div />}>
          <Component {...this.props} />
        </Suspense>
      </ErrorBoundary>
    );
  }
}
